// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { datePickerDropDownHandler } from '@shared/utils/AppHandlers';
import TerceraTIFComboBoxTemplate from '@front/templates/TerceraTIFComboBoxTemplate.html';
import { TerceraComboBox, TerceraComboBoxEvents } from './TerceraComboBox';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { TerceraTIFData } from './TerceraTIFData';
import { TIF } from '@shared/utils/Trading/OrderTif';
export class TerceraTIFComboBox extends TerceraComboBox {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraTIFComboBox';
    }
    oninit() {
        super.oninit();
        this.onGTDDateChangedFromDropDown = this.onGTDDateChangedFromDropDown.bind(this);
        this.observe('gtdDate', this.onGtdDateChanged, { init: false });
        this.observe('instrument orderType', this.trySetDefaultGTDDate);
    }
    // TODO. Refactor. Modify order screen doesn't set default gtd date because 'orderType' isn't bound to tifComboBox.
    trySetDefaultGTDDate() {
        const ins = this.get('instrument');
        if (ins === null || ins === undefined)
            return;
        const ordType = this.get('orderType');
        if (ordType === null || ordType === undefined)
            return;
        // TODO. Refactor. Remove? UGLY.
        const gtdDate = this.get('gtdDate');
        // Date is set - skip. UGLY. Remove. Only for modify order.
        if (gtdDate && gtdDate - DateTimeUtils._ZeroTime.getTime() !== 0) {
            return;
        }
        const defTif = SessionSettings.getDefaultTifForOrderType(ordType);
        void this.set('gtdDate', defTif === OrderTif.GTD ? TIF.getDefaultExpireTimeForOrderType(ordType, ins) : new Date());
    }
    private_OnMenuItemSelected(menuItem) {
        var _a, _b;
        super.private_OnMenuItemSelected(menuItem);
        const selectedItem = this.get('selectedItem');
        if (isNullOrUndefined(selectedItem))
            return;
        const tif = selectedItem.value;
        if (tif !== OrderTif.GTD)
            return;
        const el = this.find('*');
        const elRect = el.getBoundingClientRect();
        const posY = elRect.top + window.scrollY + elRect.height;
        const posX = elRect.left + window.scrollX;
        const curDate = (_a = this.get('gtdDate')) !== null && _a !== void 0 ? _a : new Date();
        const additionalParams = {};
        const minDate = new Date();
        additionalParams.minDate = minDate;
        const ins = this.get('instrument');
        if (((_b = ins === null || ins === void 0 ? void 0 : ins.isFuturesSymbol) === null || _b === void 0 ? void 0 : _b.call(ins)) === true) {
            additionalParams.maxDate = ins.lastTradeDate;
        }
        // else if (RulesSet.MAX_GTD_DURATION)
        // {
        //     var maxDate = new Date();
        //     maxDate.setTime(minDate.getTime());
        //     maxDate.setDate(maxDate.getDate() + RulesSet.MAX_GTD_DURATION);
        //     additionalParams.maxDate = maxDate;
        // }
        void this.set('isGTDFormOpened', true);
        datePickerDropDownHandler.Show(curDate, this.onGTDDateChangedFromDropDown, posX, posY, additionalParams, () => {
            void this.set('isGTDFormOpened', false);
        });
    }
    onSelectedItemChanged(newValue, oldValue) {
        super.onSelectedItemChanged(newValue, oldValue);
        this.updateGTDMenuItemText();
        if (!isNullOrUndefined(newValue) && !isNullOrUndefined(oldValue) && newValue.value === oldValue.value) {
            return;
        }
        this.fireUpdateSelectedItem();
    }
    onGtdDateChanged(newValue, oldValue) {
        this.updateGTDMenuItemText();
        if (!isNullOrUndefined(newValue) && !isNullOrUndefined(oldValue) && newValue.getTime() === oldValue.getTime()) {
            return;
        }
        this.fireUpdateSelectedItem();
    }
    fireUpdateSelectedItem() {
        this.fire(TerceraComboBoxEvents.ValueChange, new TerceraTIFData(this.get('gtdDate'), this.get('selectedItem')));
    }
    onGTDDateChangedFromDropDown(date) {
        const now = new Date();
        date.setHours(now.getHours());
        date.setMinutes(now.getMinutes());
        date.setSeconds(now.getSeconds());
        void this.set('gtdDate', date);
    }
    updateGTDMenuItemText() {
        const items = this.get('items');
        if (!isValidArray(items)) {
            return;
        }
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.value !== OrderTif.GTD) {
                continue;
            }
            const gtdDate = this.get('gtdDate');
            const gtdAdditionalText = !isNullOrUndefined(gtdDate) ? DateTimeUtils.FormatToDate(gtdDate) : null;
            if (item.additionalText !== gtdAdditionalText) {
                item.additionalText = gtdAdditionalText;
                if (!isNullOrUndefined(this.menuItems)) {
                    const gdtMenuItem = this.menuItems.find((menuItem) => menuItem.tag === OrderTif.GTD);
                    if (!isNullOrUndefined(gdtMenuItem)) {
                        gdtMenuItem.additionalText = gtdAdditionalText;
                    }
                    this.update('selectedItemLocalizedText');
                }
            }
            break;
        }
    }
}
TerceraComboBox.extendWith(TerceraTIFComboBox, {
    template: TerceraTIFComboBoxTemplate,
    data: function () {
        return {
            gtdDate: null,
            instrument: null,
            orderType: null,
            isAllowEmpty: false,
            isGTDFormOpened: false
        };
    }
});
